import { Button } from "antd";
import { useBankFeeds } from "./bankFeedsAuthProvider";
import { BankFeedsConsentHeader } from "./header";
import { HowIsYourDataUsed } from "./howIsYourDataUsed";
import { TermsAndConditionsText } from "./termsAndConditions";

export const DataSharing = ({
  cancelHandler,
  continueToLoginHandler,
}: {
  cancelHandler: () => void;
  continueToLoginHandler: () => void;
}) => {
  const { orgInfo } = useBankFeeds();

  return (
    <>
      <BankFeedsConsentHeader
        title={
          orgInfo?.name ? (
            <span>
              {orgInfo?.name} securely connects to your <br /> accounts while
              protecting your data
            </span>
          ) : (
            <span>
              Securely connect to your <br /> account while protecting your data
            </span>
          )
        }
        financialInstitutionLogo={orgInfo?.companyLogoUrl ?? undefined}
      />
      <HowIsYourDataUsed
        title="How your data is used"
        description={`When you link your ${
          orgInfo?.name ?? ""
        } account, you'll be able to access your transactions in your connected accounting software for quick and easy reconciliation.`}
        hideIcon={true}
        containerClassName="mt-[16px]"
      />
      <HowIsYourDataUsed
        title="What data is shared"
        description={`Your connected accounting software will access your data until you withdraw consent. You can unlink your account any time, and your credentials won’t be shared.`}
        hideIcon={true}
      >
        <ul className="list-disc list-inside mt-[12px] ps-3">
          <li className="text-slate-500 marker:text-slate-500">
            Account Summary Information
          </li>
          <li className="text-slate-500 marker:text-slate-500">
            Account Payments Information
          </li>
          <li className="text-slate-500 marker:text-slate-500">Transactions</li>
        </ul>
      </HowIsYourDataUsed>
      <Button
        className="
        mt-[16px]
        flex 
        justify-center
        items-center 
        py-4 sm:py-5
        rounded-md
        font-medium
        bg-[#fff] border-slate-300 
        hover:bg-[#F9FAFC] 
        hover:border-[#212430] hover:text-[#212430] 
      "
        block
        onClick={cancelHandler}
      >
        Cancel
      </Button>
      <Button
        className={` 
        flex 
        justify-center 
        items-center 
        py-4 sm:py-5 
        mt-2
        ${!orgInfo?.termsAndConditions && "mb-[32px]"}
        rounded-md 
        text-white
        font-medium
        bg-[#212430] 
        hover:bg-[#020211] hover:text-[#fff] hover:border-[#020211]
      `}
        block
        onClick={continueToLoginHandler}
      >
        Continue to login
      </Button>
      {orgInfo?.termsAndConditions && (
        <div className="mt-[8px] px-14 text-xs sm:text-sm">
          <TermsAndConditionsText
            termsAndConditions={orgInfo.termsAndConditions}
          />
        </div>
      )}
    </>
  );
};
